import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModal from '../../components/core/SMCModal';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import {SMCCheckbox} from '../../components/Simple/SMCCheckbox';
import Api from '../../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import {useSMCSnackbar} from '../../utils/hooks';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {GatewayGetSchema} from '../../api/DBSchema/Gateway';

const customSiteSchema = GatewayGetSchema.pages.sslInspection.CpSSLBypassCustomSiteSchema;

/**
 * Custom Sites Editor Modal
 * @param {Object} params
 * @param {Boolean} params.isOpen Is window open
 * @param {Integer} params.width 
 * @param {Integer} params.height
 * @param {Function} params.onCancel Window cancel function
 * @param {Function} params.onSuccess Success callback
 * @param {Object} params.defaultObject
 * @param {string} props.baseObjectName
 * @param {string} props.objectType
 */
function SSLCustomSiteEditorModal({
    isOpen = false,
    width = 450,
    height = 300,
    onCancel,
    onSuccess,
    defaultObject,
    baseObjectName,
    objectType,
    title
}) {
    const { t } = useTranslation();
    const { enqueueErrorSnackbar } = useSMCSnackbar();
    const { getErrorMessage } = useSMCErrorHandler();

    const [value, setValue] = useState('');
    const [name, setName] = useState('');
    const [regex, setRegex] = useState(false);
    
    const onFinish = async () => {

        const retVal = {
            [customSiteSchema.value]: value,
            [customSiteSchema.name]: name,
            [customSiteSchema.regex]: regex,
       
        };
    
        try {
            await Api.validateSSLCustomSite(objectType, baseObjectName, retVal);
        } catch (e) {
            const errorMessage = getErrorMessage(e);
            enqueueErrorSnackbar(errorMessage, {
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'bottom'
                }
            });
            return;
        }
        onSuccess(retVal);
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            
            setValue('');
            setName('');
            setRegex(false);
        }

        if (defaultObject) {
			setValue(defaultObject[customSiteSchema.value]);
			setName(defaultObject[customSiteSchema.name]);
			setRegex(defaultObject[customSiteSchema.regex]);
        }
    }, [isOpen, defaultObject]);

    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onCancel}
            width={width}
            height={height}
            title={title}
        >
            <SMCModalBody>
               
            		<SMCTextInput
						width={220}
						value={value}
						onChange={e => setValue(e.target.value)}
						label={"URL"}
					/>
					<SMCTextInput
						width={220}
						value={name}
						onChange={e => setName(e.target.value)}
						label={"Name"}
						tooltip={t('com.sofaware.db.OBJECT_NAME_TOOLTIP')}
					/>
					<SMCCheckbox
						checked={regex}
						onChange={e => setRegex(e.target.checked)}
                        label={t("SMP.PLAN.SEC_SOFT_BLADES.CUSTOM_URL_REGEX")}
                        tooltip={t("SMP.PLAN.SEC_SOFT_BLADES.CUSTOM_URL_REGEX_NOTE")}
					/>

            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default SSLCustomSiteEditorModal;